import { render, staticRenderFns } from "./addPumpTruckCompany.vue?vue&type=template&id=d4c68fea&scoped=true"
import script from "./addPumpTruckCompany.vue?vue&type=script&lang=js"
export * from "./addPumpTruckCompany.vue?vue&type=script&lang=js"
import style0 from "./addPumpTruckCompany.vue?vue&type=style&index=0&id=d4c68fea&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c68fea",
  null
  
)

export default component.exports